import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";


const DEBOUNCE_TIME = 150;


const useScroll = (isLoading, totalPages) => {
  const [searchParams] = useSearchParams();
  const pageSearchParam = searchParams.get("page");
  const [page, setPage] = useState(+pageSearchParam || 1);
  const ref = useRef();


  const isBottom = (el) => {
    return (
      parseInt(el.getBoundingClientRect().bottom) - 150 <= window.innerHeight
    );
  };

  const debounce = (func, delay) => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(func, delay);
    };
  };

  const trackScrolling = () => {
    if (isLoading || !ref.current || page >= totalPages) return;
    if (isBottom(ref.current)) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    if(page === 1) return
    const search = window.location.search;
    const url = window.location.pathname;
    const hash = window.location.hash
    const normalizedSearchQuery = search.replace(/([&?])page=\d+/g, "");

    window.history.replaceState(
        null,
        "",
        `${url + normalizedSearchQuery}${normalizedSearchQuery ? "&" : "?"
        }page=${page}${hash ? hash : ""}`
    );
  }, [page]);


  useEffect(() => {
    const debouncedScroll = debounce(trackScrolling, DEBOUNCE_TIME);

    document.addEventListener("scroll", debouncedScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", debouncedScroll);
    };
  }, [totalPages, page,  isLoading]);

  return { page, ref, setPage };
};

export default useScroll;
